import React, { useEffect } from "react";
import { GetDataGiftCards, UseCoreGiftCard } from "state/giftCards";
import 'swiper/css';
import ElectronicGiftCard from "./ElectronicGiftCard";
import InformationOrder from "./InformationOrder";
import OrderSummary from "./OrderSummary";

interface Props {
    price: string,
    brand:string,
    product:string,
    phoneNumber?:string,
    newbrand?: string
}
const GiftCards:React.FC<Props> = ({price, brand, product, phoneNumber, newbrand}) => {
    UseCoreGiftCard()
    const dataGiftcards = GetDataGiftCards()
    const { isActiveScreen } = dataGiftcards
    
    useEffect(() => {
        const unloadCallback = (event) => {
          event.preventDefault();
          // eslint-disable-next-line no-param-reassign
          event.returnValue = "";
          return "";
        };
      
        window.addEventListener("beforeunload", unloadCallback);
        return () => window.removeEventListener("beforeunload", unloadCallback);
    }, []);

    return (
        <>
            {
                isActiveScreen === 0 ? 
                <>
                    <ElectronicGiftCard priceRoute={price} brandRoute={brand} productRoute={product} phoneNumberRoute={phoneNumber} newbrand={newbrand} />
                </>
                : isActiveScreen === 1 ?  
                    <OrderSummary /> 
                    : <InformationOrder/>
            }
        </>
        
    )
}

export default GiftCards